<template>
  <div>
    <v-row>
      <v-col>
        <v-card>
          <v-card-text>
            <p>Total Inventory</p>
            Coming Soon
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },

  methods: {},
};
</script>

<style lang="scss" scoped></style>
